<template>
  <v-app>
    <!-- Custom Cursor -->
    <CustomCursor />
    
    <!-- Use DashboardLayout for authenticated routes -->
    <DashboardLayout v-if="shouldShowDashboard">
      <router-view />
    </DashboardLayout>
    
    <!-- Use AuthLayout for login, register, etc. -->
    <AuthLayout v-else-if="isAuthRoute">
      <router-view />
    </AuthLayout>
    
    <!-- Print routes render without any layout -->
    <router-view v-else-if="isPrintRoute" />
    
    <!-- For any other routes, use direct view -->
    <router-view v-else />
  </v-app>
</template>

<script>
import DashboardLayout from '@/components/DashboardLayout.vue';
import AuthLayout from '@/components/AuthLayout.vue';
import CustomCursor from '@/components/global/CustomCursor.vue';
import '@/assets/styles/cursor.css';

export default {
  name: 'App',
  components: {
    DashboardLayout,
    AuthLayout,
    CustomCursor
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated || false;
    },
    isAuthRoute() {
      // Auth routes include 'login', 'register', 'forgot-password', etc.
      return this.$route.meta.layout === 'auth' || 
             this.$route.name === 'login' ||
             this.$route.name === 'register' ||
             this.$route.path.includes('/auth/');
    },
    isPrintRoute() {
      return this.$route.meta.layout === 'print';
    },
    shouldShowDashboard() {
      return this.isAuthenticated && !this.isAuthRoute && !this.isPrintRoute;
    }
  }
}
</script>

<style>
/* Global styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
  color: #333;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s, opacity 0.3s;
}

.btn-primary {
  background-color: #4A6282;
  color: white;
}

.btn-primary:hover {
  background-color: #3d5270;
}

.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style> 